import AppBar from "@mui/material/AppBar";
import Box from "@mui/joy/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { routes } from "../routes";

import { Link as RouterLink } from "react-router-dom";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";

import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";

const linkStyle = {
  color: "#fff",
  fontWeight: 700,
  margin: "0 4px",
  textDecoration: "none",
};

export interface AppBarProps {
  toggleDrawer: ((event: React.SyntheticEvent) => void);
}

const PrimaryAppBar = ({ toggleDrawer, ...props }: AppBarProps) => {
  const theme = useTheme();

  const midToLarge = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const smallToMid = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const lessThanSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const showNavBarMenu = lessThanSmall || smallToMid;

  const shortcuts: Array<ShortCut> = [];

  //TODO: Allow users to set the direction based on handedness; otherwsie
  const handedness: "left" | "right" | undefined = undefined;
  const textDirection: "ltr" | "rtl" = "rtl";
  const alignment: "start" | "end" = handedness === "right" ? "end" : "start";

  return (
    <AppBar sx={{ boxShadow: "none", position: "relative" }}>
      {showNavBarMenu ? (
        <MobileNavBar
          shortcuts={shortcuts}
          toggleDrawer={toggleDrawer}
          alignment={alignment}
          
        />
      ) : (
        <NavigationBar />
      )}
    </AppBar>
  );
};

const NavigationBar = () => {
  return (
    <Stack direction="row">
      <Box sx={{ flexGrow: 1, a: linkStyle }}>
        {routes
          .filter((route) => route.active)
          .map((route) => (
            <Button key={route.name}>
              <RouterLink to={route.url}>{route.name}</RouterLink>
            </Button>
          ))}
      </Box>
      {/* <Box sx={{ position: "absolute", right: 10 }}>
          <Stack>
            <ButtonGroup>
              {["spoilers", "colorMode"].map((item, index) => (
                <Button variant='text' color='secondary' key={index}>{item}</Button>
              ))}
            </ButtonGroup>
          </Stack>
        </Box> */}
    </Stack>
  );
};

// TODO: implement shortcuts that users can added to the navbar for quick actions
type ShortCut = "";

export interface MobileNavBarProps {
  shortcuts: Array<ShortCut>;
  alignment: "start" | "end";
  toggleDrawer: ((event: React.SyntheticEvent) => void);
}

const MobileNavBar = ({toggleDrawer, shortcuts,...props}: MobileNavBarProps) => {
  const theme = useTheme();

  return (
    <Stack alignItems={props.alignment}>
      <IconButton
        aria-label="Nav Drawer Menu Button"
        onClick={toggleDrawer}
        sx={{ color: theme.palette.text.primary }}
        size="large"
      >
        <MenuIcon />

        {shortcuts.map((shortcut) => (
          <IconButton>{shortcut}</IconButton>
        ))}
      </IconButton>
    </Stack>
  );
};

export default PrimaryAppBar;
